__turbopack_context__.v({
  "subtitle": "TitleSection-module-scss-module__0IYdmq__subtitle",
  "title": "TitleSection-module-scss-module__0IYdmq__title",
  "titleSection": "TitleSection-module-scss-module__0IYdmq__titleSection",
});
